import { DeviceType, School } from '../types';

export const district = {
  name: 'Bay County School District',
  shortName: 'Bay County SD',
};

export const account = {
  firstName: 'Morgan',
  lastName: 'Hale',
  get name() {
    return `${this.firstName} ${this.lastName}`;
  },
  email: 'morgan+baycounty@getakko.com',
  role: 'Owner',
  initials: 'MH',
};

export const schools: School[] = [
  { slug: 'chesapeake-middle-school', name: 'Chesapeake Middle School', studentsCovered: 17 },
  { slug: 'kittering-elementary-school', name: 'Kittering Elementary School', studentsCovered: 12 },
  { slug: 'long-shore-high-school', name: 'Long Shore High School', studentsCovered: 6 },
];

export const schoolFilterOptions = ['All Schools', district.name, ...schools.map((s) => s.name)];

export const deviceTypeOptions: (DeviceType | 'All Device Types')[] = [
  'All Device Types',
  'Phone',
  'Laptop',
  'Tablet',
  'Smartwatch',
  'Desktop',
  'VR/AR Headset',
  'Other',
  'Portable Router',
  'Security Camera',
];

export const deviceMakeOptions = [
  'Acer',
  'Apple',
  'Asus',
  'CTL',
  'Dell',
  'Lenovo',
  'HP',
  'Samsung',
  'Dynabook',
];

export interface PlanDefinition {
  id: string;
  slug: string;
  label: string;
  shortLabel: string;
  typeLabel: string;
}

export const plans: Record<string, PlanDefinition> = {
  ipad350: {
    id: 'ipad350',
    slug: 'edu-ipad-admb-350-0fees',
    label: 'EDU - iPad - AD/MB - 350 max - 0 service fees',
    shortLabel: 'Apple iPad (10th Gen)',
    typeLabel: 'iPad',
  },
  chromebook350: {
    id: 'chromebook350',
    slug: 'edu-chromebooknontouch-admb-350-0fees',
    label: 'EDU - Chromebook - Non-Touch - AD/MB - 350 max - 0 service fees',
    shortLabel: 'Lenovo Chromebook',
    typeLabel: 'Chromebook - Non-Touch',
  },
  chromebookTheft: {
    id: 'chromebookTheft',
    slug: 'edu-chromebooknontouch-admbtheftloss-350-0fees',
    label: 'EDU - Chromebook - Non-Touch - AD/MB/Theft/Loss - 350 max - 0 service fees',
    shortLabel: 'Grades 6-8: Lenovo Chromebook - with Theft & Loss',
    typeLabel: 'Chromebook - Non-Touch',
  },
  macbook800: {
    id: 'macbook800',
    slug: 'edu-macbook-admb-800-0fees',
    label: 'EDU - MacBook - AD/MB - 800 max - 0 service fees',
    shortLabel: 'Apple MacBook Air',
    typeLabel: 'MacBook',
  },
  macbookTheft: {
    id: 'macbookTheft',
    slug: 'edu-macbook-admbtheftloss-800-0fees',
    label: 'EDU - MacBook - AD/MB/Theft/Loss - 800 max - 0 service fees',
    shortLabel: 'Apple MacBook Air',
    typeLabel: 'MacBook',
  },
  ipadGroup: {
    id: 'ipadGroup',
    slug: 'edu-ipad-ad-300-0fees',
    label: 'EDU - iPad - AD - 300 max - 0 service fees',
    shortLabel: 'Apple iPad',
    typeLabel: 'iPad',
  },
};

export function planLabel(planId: string): string {
  return plans[planId]?.label ?? planId;
}

export function planShortLabel(planId: string): string {
  return plans[planId]?.shortLabel ?? planId;
}

export function planSlug(planId: string): string {
  return plans[planId]?.slug ?? planId;
}

export function planTypeLabel(planId: string): string {
  return plans[planId]?.typeLabel ?? '';
}

export function planDeviceType(planId: string): DeviceType {
  return plans[planId]?.typeLabel === 'iPad' ? 'Tablet' : 'Laptop';
}

export function schoolName(slug: string | null): string {
  if (!slug) return '-';
  return schools.find((s) => s.slug === slug)?.name ?? district.name;
}

export function schoolBySlug(slug: string | undefined) {
  return schools.find((s) => s.slug === slug);
}
